var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoSendPickupMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "65px",
    viewBox: "0 0 52 65",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "atoms/marker/pickup-marker-drop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-27.3%",
    y: "-21.1%",
    width: "154.5%",
    height: "146.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.15 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-42.9%",
    y: "-63.7%",
    width: "185.7%",
    height: "227.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ID-Estimate-Details",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.1b-Fare-Detail-CardLoaded",
    transform: "translate(-83.000000, -118.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atoms/from-to-pin/map-route",
    transform: "translate(87.000000, 38.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icoPickupPin",
    transform: "translate(0.000000, 82.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5,56.2725692 C24.4329966,56.2725692 26,56.4329966 26,54.5 C26,52.5670034 24.4329966,51.5668307 22.5,51.5668307 C20.5670034,51.5668307 19,52.5670034 19,54.5 C19,56.4329966 20.5670034,56.2725692 22.5,56.2725692 Z",
    id: "Drop-shadow",
    fillOpacity: 0.4,
    fill: "#000000",
    filter: "url(#filter-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Pin"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,0 C34.0287619,0 43.8027752,9.65110742 43.9970526,21.6361112 L44,22 C44,32.7291049 36.3217494,41.6643718 26.1577096,43.6078208 C26.1005058,43.742103 26.0484679,43.8727229 26,44 C25.3483824,45.7111533 24.5236592,48.4053688 23.5258304,52.0826464 L23.3946783,52.5678613 C23.2511241,53.1011518 22.7024331,53.4170955 22.1691427,53.2735413 C21.8357416,53.1837945 21.5722239,52.9284056 21.4720781,52.5979793 C20.2773727,48.656106 19.3607683,45.7901129 18.7222648,44 C18.6921973,43.9157026 18.6601563,43.8299388 18.6261417,43.7427085 C8.07714391,42.1194953 0,33.0051974 0,22 C0,9.97123815 9.65110742,0.197224763 21.6361112,0.00294737144 L22,0 Z",
    id: "Main-pin",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Main-pin-color",
    fill: "#00AA13",
    x: 2,
    y: 2,
    width: 40,
    height: 40,
    rx: 20
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Border-pin-color",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    x: 1.5,
    y: 1.5,
    width: 41,
    height: 41,
    rx: 20.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Fill-6",
    transform: "translate(10.000000, 10.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.886185,7.90236844 L13.8647522,0.646397325 C13.8051654,0.596658011 13.73962,0.56482485 13.6760608,0.523043827 C13.580722,0.457387932 13.4873695,0.387752893 13.386072,0.334034434 C13.2966919,0.286284692 13.2033393,0.254451532 13.1080005,0.216649653 C13.0245791,0.18282692 12.9411577,0.143035468 12.8537638,0.117171025 C12.7504801,0.0853378642 12.6471964,0.0714108563 12.5439127,0.0515151308 C12.4585051,0.0355985503 12.3750836,0.0137132522 12.2896759,0.00575496194 C12.1923509,-0.00419290084 12.0970121,0.00177581683 12.0016734,0.00177581683 C11.9043483,0.00177581683 11.8090096,-0.00419290084 11.7116845,0.00575496194 C11.6262769,0.0137132522 11.5428554,0.0355985503 11.4574478,0.0515151308 C11.3541641,0.0714108563 11.2488942,0.0853378642 11.1475967,0.117171025 C11.0602028,0.143035468 10.9807538,0.18282692 10.8973324,0.21466008 C10.8019936,0.252461959 10.7046686,0.286284692 10.6133023,0.334034434 C10.5159772,0.38576332 10.4305696,0.451419215 10.3392032,0.511106391 C10.2716716,0.558856133 10.1981813,0.592678866 10.1346221,0.646397325 L1.11318923,7.90236844 C-0.167925739,8.9349566 -0.374493114,10.8131131 0.656357536,12.098377 C1.24428006,12.8325292 2.11027406,13.2125376 2.98222673,13.2125376 C3.63569467,13.2125376 4.29512129,12.9996533 4.84530555,12.5559787 L9.02035,9.1955906 L9.02035,21.0156412 C9.02035,22.6649968 10.3531068,24 11.9996871,24 C13.6462675,24 14.9790243,22.6649968 14.9790243,21.0156412 L14.9790243,9.1955906 L19.1540687,12.5559787 C19.704253,12.9996533 20.3636796,13.2125376 21.0191338,13.2125376 C21.8910864,13.2125376 22.7550942,12.8325292 23.3430167,12.098377 C24.3738674,10.8131131 24.1692862,8.9349566 22.886185,7.90236844"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoSendPickupMarker);
export default __webpack_public_path__ + "static/media/go-send-pickup-marker.15518e2044b4779a89795579aa84e924.svg";
export { ForwardRef as ReactComponent };